// import { useState, useEffect } from 'react';
// import { FiBook, FiVideo, FiMusic, FiShoppingCart ,FiDollarSign, FiCreditCard, FiRepeat } from "react-icons/fi";
// import { FaPodcast } from "react-icons/fa";
// import PurchaseCourses from './PurchaseCourses';
// import useCurrentTeacher from '../../../hooks/useCurrentTeacher';
// import useRegisterStudentCourses from '../../../hooks/useRegisterStudentCourses';
// const TeacherDashboard = () => {
//   const { teacher } = useCurrentTeacher();
//   const { learningItems } = useRegisterStudentCourses(teacher?.id);

//   const [courses, setCourses] = useState([]);
//   const [videoCourses, setVideoCourses] = useState([]);
//   const [audioCourses, setAudioCourses] = useState([]);
//   const [podcastsCourses, setPodcastsCourses] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [amountCheck,setAmountCheck]=useState(false)
//   const [paymentStatus, setPaymentStatus] = useState("pending");
//   const BASE_URL = process.env.REACT_APP_BASE_URL;
//   // Fetch total amount 
//   const fetchTotalAmount = async () => {
//     try {
//       setAmountCheck(true)
//       const res = await fetch(`${BASE_URL}/student/getTeacherTotalAmount/${teacher?.id}/`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           "x-api-key": process.env.REACT_APP_X_API_KEY
//         },
//       });
//       const data = await res.json();
//       //  console.log("The total amount of teacher",data?.total_amount)
//       //  console.log("The remaining balance of teacher",teacher?.withdraw_amount)
//       if (data.success) setTotalAmount(data.total_amount);
//     } catch (err) {
//       console.error("Error fetching total amount:", err);
//     } finally {
//       setAmountCheck(false)
//     }
//   };

//  useEffect(() => {
//   if (!teacher?.id) return;

//   fetchTotalAmount();
// }, [teacher?.id]);
// useEffect(() => {
//   if (paymentStatus === "pending") return;

//   fetchTotalAmount();
// }, [paymentStatus]);

//   // Fetch dashboard courses & media
//   const fetchDashboardData = async () => {
//     if (!teacher?.id) return;
//     const token = localStorage.getItem("access_token");

//     const urls = {
//       courses: `${BASE_URL}/courses/list/?teacher_id=${teacher.id}`,
//       videos: `${BASE_URL}/courses/videos/?teacher_id=${teacher.id}`,
//       audios: `${BASE_URL}/courses/audios/?teacher_id=${teacher.id}`,
//       podcasts: `${BASE_URL}/courses/podcasts/?teacher_id=${teacher.id}`,
//     };

//     const fetchOptions = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_X_API_KEY } };

//     try {
//       const [courseData, videoData, audioData, podcastData] = await Promise.all([
//         fetch(urls.courses, fetchOptions).then(r => r.json()),
//         fetch(urls.videos, fetchOptions).then(r => r.json()),
//         fetch(urls.audios, fetchOptions).then(r => r.json()),
//         fetch(urls.podcasts, fetchOptions).then(r => r.json()),
//       ]);

//       setCourses(courseData.results ?? courseData ?? []);
//       setVideoCourses(videoData.results ?? videoData ?? []);
//       setAudioCourses(audioData.results ?? audioData ?? []);
//       setPodcastsCourses(podcastData.results ?? podcastData ?? []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchDashboardData();
//   }, [teacher?.id]);

//   const statsData = [
//     { id: 1, title: 'Total Courses', value: courses.length, icon: <FiBook />, type: 'courses' },
//     { id: 2, title: 'Total Videos', value: videoCourses.length, icon: <FiVideo />, type: 'videos' },
//     { id: 3, title: 'Total Audios', value: audioCourses.length, icon: <FiMusic />, type: 'audios' },
//     { id: 4, title: 'Total Podcasts', value: podcastsCourses.length, icon: <FaPodcast />, type: 'podcasts' },
//     { id: 5, title: 'Total Purchases', value: learningItems?.length, icon: <FiShoppingCart />, type: 'purchases' },
//     { 
//   id: 6, 
//   title: 'Total Income', 
//   value: `$${Number(totalAmount ?? 0).toFixed(2)}`, 
//   icon: <FiDollarSign />, 
//   type: 'income' 
// },

// { 
//   id: 7, 
//   title: 'Remaining Balance', 
//    value: amountCheck
//     ? `$0.00`
//     : `$${Number(
//         (totalAmount ?? 0) - (teacher?.withdraw_amount ?? 0)
//       ).toFixed(2)}`, 
//   icon: <FiCreditCard />, 
//   type: 'remaining' 
// },

// { 
//   id: 8, 
//   title: 'Withdrawn Amount', 
//   value: `$${Number(teacher?.withdraw_amount ?? 0).toFixed(2)}`, 
//   icon: <FiRepeat />, 
//   type: 'withdraw' 
// },
//   ];

//   // ------------------------ HANDLE WITHDRAW ------------------------
// const handleWithDraw = async () => {
//   if (!email) return alert("Email is required");

//   // Calculate remaining withdrawable amount
//   const remainingAmount = (totalAmount ?? 0) - (teacher?.withdraw_amount ?? 0);
//   if (!remainingAmount || remainingAmount < 1)
//     return alert("Amount min $1");

//   setLoading(true);

//   try {
//     // Step 1: Update PayPal email & set payout_status to "pending"
//     const updateRes = await fetch(`${BASE_URL}/teacher/${teacher?.id}/update/`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//         "x-api-key": process.env.REACT_APP_X_API_KEY,
//       },
//       body: JSON.stringify({ paypal_email: email, payout_status: "pending" }),
//     });

//     if (!updateRes.ok) throw new Error("Failed to update PayPal email");

//     // Step 2: Trigger payout with correct remaining amount
//     const payoutRes = await fetch(`${BASE_URL}/paypal/withdraw-payout/`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//         "x-api-key": process.env.REACT_APP_X_API_KEY,
//       },
//       body: JSON.stringify({ 
//         paypal_email: email, 
//         amount: Number(remainingAmount.toFixed(2)) // send only remaining balance
//       }),
//     });

//     if (!payoutRes.ok) throw new Error("Failed to process payout");

//     // Step 3: Poll teacher status until webhook updates (up to 1 minute)
//     const startTime = Date.now();
//     const timeout = 60000; // 60 seconds
//     let payoutStatus = "pending";

//     while (payoutStatus === "pending" && Date.now() - startTime < timeout) {
//       await new Promise(r => setTimeout(r, 2000)); // 2s interval

//       try {
//         const statusRes = await fetch(`${BASE_URL}/teacher/${teacher?.id}/`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//             "x-api-key": process.env.REACT_APP_X_API_KEY,
//           },
//         });

//         if (!statusRes.ok) continue; // skip this iteration if error

//         const statusData = await statusRes.json();

//         // Ensure we default to "pending" if webhook hasn't updated yet
//         payoutStatus = statusData?.payout_status ?? "pending";

//         console.log("Polling status:", payoutStatus, "Elapsed:", Date.now() - startTime);
//       } catch (err) {
//         console.warn("Error fetching status, retrying...", err);
//       }
//     }

//     // Step 4: Handle final payout status
//     if (payoutStatus === "complete") {
//       alert("✅ Payment completed successfully");
//       setPaymentStatus("complete")
//       fetchTotalAmount();
//       fetchDashboardData();
//     } else if (payoutStatus === "unclaimed") {
//       setPaymentStatus("unclaimed")
//       alert("⚠️ Payment is unclaimed, please check your PayPal account.");
//     } else if (payoutStatus === "failed") {
//       alert("❌ Payment failed, please try again.");
//       setPaymentStatus("failed")
//     } else {
//       // alert("⏱ Payment processing timeout, please check later."); // only after 60s
//       alert("⏱ Payment done successfully. if payment not updated please refersh the page"); // only after 60s
//       setPaymentStatus("complete")
//       fetchTotalAmount();
//       fetchDashboardData();
//       window.location.reload()
//     }

//   } catch (err) {
//     console.error(err);
//     alert("Something went wrong. Please try again.");
//   } finally {
//     setLoading(false);
//     setOpen(false);
//   }
// };
//   // ------------------------ JSX ------------------------
//   return (
//     <div className="p-3 md:p-6">
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//         {statsData.map(stat => (
//           <div key={stat.id} className="flex items-center min-h-[100px] p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-all">
//             <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
//               <div className="text-[#0f6abf] text-xl">{stat.icon}</div>
//             </div>
//             <div className="ml-4 flex-1">
//               <div className="text-sm font-medium text-gray-600">{stat.title}</div>
//               <div className="text-xl font-semibold text-gray-900">{stat.value}</div>
//               {stat.id === 7 && (
//                 <button onClick={() => setOpen(true)} className="mt-2 w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
//                   Withdraw
//                 </button>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//       {/* Withdraw Modal */}
//       {open && (
//         <>
//           <div onClick={() => setOpen(false)} className="fixed inset-0 bg-black/50 z-40" />
//           <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-xl w-[90%] max-w-md z-50">
//             <div className="p-6 border-b border-gray-100 flex items-center justify-between">
//               <h2 className="text-lg font-semibold text-gray-900">Withdraw Amount</h2>
//               <button onClick={() => setOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors">
//                 <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
//             <div className="p-6">
//               <p className="text-sm text-gray-600 mb-4">Enter your PayPal email to withdraw the amount.</p>
//               <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your PayPal email" className="w-full px-4 py-3 mb-4 bg-gray-50 border border-gray-300 rounded-xl focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all" />
//               <button onClick={handleWithDraw} disabled={loading} className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
//                 {loading ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : "Withdraw Amount"}
//               </button>
//             </div>
//           </div>
//         </>
//       )}

//       <PurchaseCourses />
//     </div>
//   );
// };

// export default TeacherDashboard;
import { useState, useEffect } from 'react';
import { FiBook, FiVideo, FiMusic, FiShoppingCart ,FiDollarSign, FiCreditCard, FiRepeat } from "react-icons/fi";
import { FaPodcast } from "react-icons/fa";
import PurchaseCourses from './PurchaseCourses';
import useCurrentTeacher from '../../../hooks/useCurrentTeacher';
import useRegisterStudentCourses from '../../../hooks/useRegisterStudentCourses';
const TeacherDashboard = () => {
  const { teacher,fetchCurrentTeacher } = useCurrentTeacher();
  const { learningItems } = useRegisterStudentCourses(teacher?.id);
  // console.log("The teacher is:",teacher)
  const [courses, setCourses] = useState([]);
  const [videoCourses, setVideoCourses] = useState([]);
  const [audioCourses, setAudioCourses] = useState([]);
  const [podcastsCourses, setPodcastsCourses] = useState([]);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [amountCheck,setAmountCheck]=useState(false)
  const [paymentStatus, setPaymentStatus] = useState("pending");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  // Fetch total amount 
 
useEffect(() => {
  if (paymentStatus === "pending") return;
  fetchCurrentTeacher()
}, [paymentStatus]);

  // Fetch dashboard courses & media
  const fetchDashboardData = async () => {
    if (!teacher?.id) return;
    const token = localStorage.getItem("access_token");

    const urls = {
      courses: `${BASE_URL}/courses/list/?teacher_id=${teacher.id}`,
      videos: `${BASE_URL}/courses/videos/?teacher_id=${teacher.id}`,
      audios: `${BASE_URL}/courses/audios/?teacher_id=${teacher.id}`,
      podcasts: `${BASE_URL}/courses/podcasts/?teacher_id=${teacher.id}`,
    };

    const fetchOptions = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_X_API_KEY } };

    try {
      const [courseData, videoData, audioData, podcastData] = await Promise.all([
        fetch(urls.courses, fetchOptions).then(r => r.json()),
        fetch(urls.videos, fetchOptions).then(r => r.json()),
        fetch(urls.audios, fetchOptions).then(r => r.json()),
        fetch(urls.podcasts, fetchOptions).then(r => r.json()),
      ]);

      setCourses(courseData.results ?? courseData ?? []);
      setVideoCourses(videoData.results ?? videoData ?? []);
      setAudioCourses(audioData.results ?? audioData ?? []);
      setPodcastsCourses(podcastData.results ?? podcastData ?? []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [teacher?.id]);

  const statsData = [
    { id: 1, title: 'Total Courses', value: courses.length, icon: <FiBook />, type: 'courses' },
    { id: 2, title: 'Total Videos', value: videoCourses.length, icon: <FiVideo />, type: 'videos' },
    { id: 3, title: 'Total Audios', value: audioCourses.length, icon: <FiMusic />, type: 'audios' },
    { id: 4, title: 'Total Podcasts', value: podcastsCourses.length, icon: <FaPodcast />, type: 'podcasts' },
    { id: 5, title: 'Total Purchases', value: learningItems?.length, icon: <FiShoppingCart />, type: 'purchases' },
    { 
  id: 6, 
  title: 'Total Income', 
  value: Number(teacher?.total_earned || 0).toFixed(2),
  icon: <FiDollarSign />, 
  type: 'income' 
},

{ 
  id: 7, 
  title: 'Remaining Balance', 
   value: Number(teacher?.available_balance || 0).toFixed(2),
  icon: <FiCreditCard />, 
  type: 'remaining' 
},

{ 
  id: 8, 
  title: 'Withdrawn Amount', 
  value: Number(teacher?.withdraw_amount || 0).toFixed(2),
  icon: <FiRepeat />, 
  type: 'withdraw' 
},
  ];

  // ------------------------ HANDLE WITHDRAW ------------------------
const handleWithDraw = async () => {
  if (!email) return alert("Email is required");

  // Calculate remaining withdrawable amount
  const remainingAmount =
  Number(teacher?.total_earned || 0) -
  Number(teacher?.withdraw_amount || 0);
  
  if (!remainingAmount || remainingAmount < 1)
    return alert("Amount min $1");

  setLoading(true);

  try {
    // Step 1: Update PayPal email & set payout_status to "pending"
    const updateRes = await fetch(`${BASE_URL}/teacher/${teacher?.id}/update/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
      body: JSON.stringify({ paypal_email: email, payout_status: "pending" }),
    });

    if (!updateRes.ok) throw new Error("Failed to update PayPal email");

    // Step 2: Trigger payout with correct remaining amount
    const payoutRes = await fetch(`${BASE_URL}/paypal/withdraw-payout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
      body: JSON.stringify({ 
        paypal_email: email, 
        amount: Number(remainingAmount.toFixed(2)) // send only remaining balance
      }),
    });

    if (!payoutRes.ok) throw new Error("Failed to process payout");

    // Step 3: Poll teacher status until webhook updates (up to 1 minute)
    const startTime = Date.now();
    const timeout = 60000; // 60 seconds
    let payoutStatus = "pending";

    while (payoutStatus === "pending" && Date.now() - startTime < timeout) {
      await new Promise(r => setTimeout(r, 2000)); // 2s interval

      try {
        const statusRes = await fetch(`${BASE_URL}/teacher/${teacher?.id}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        if (!statusRes.ok) continue; // skip this iteration if error

        const statusData = await statusRes.json();

        // Ensure we default to "pending" if webhook hasn't updated yet
        payoutStatus = statusData?.payout_status ?? "pending";

        console.log("Polling status:", payoutStatus, "Elapsed:", Date.now() - startTime);
      } catch (err) {
        console.warn("Error fetching status, retrying...", err);
      }
    }

    // Step 4: Handle final payout status
    if (payoutStatus === "complete") {
      alert("✅ Payment completed successfully");
      setPaymentStatus("complete")
      fetchCurrentTeacher();
      fetchDashboardData();
    } else if (payoutStatus === "unclaimed") {
      setPaymentStatus("unclaimed")
      alert("⚠️ Payment is unclaimed, please check your PayPal account.");
    } else if (payoutStatus === "failed") {
      alert("❌ Payment failed, please try again.");
      setPaymentStatus("failed")
    } else {
      // alert("⏱ Payment processing timeout, please check later."); // only after 60s
      alert("⏱ Payment done successfully. if payment not updated please refersh the page"); // only after 60s
      setPaymentStatus("complete")
      fetchCurrentTeacher();
      fetchDashboardData();
      window.location.reload()
    }

  } catch (err) {
    console.error(err);
    alert("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
    setOpen(false);
  }
};
  // ------------------------ JSX ------------------------
  return (
    <div className="p-3 md:p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {statsData.map(stat => (
          <div key={stat.id} className="flex items-center min-h-[100px] p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-all">
            <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
              <div className="text-[#0f6abf] text-xl">{stat.icon}</div>
            </div>
            <div className="ml-4 flex-1">
              <div className="text-sm font-medium text-gray-600">{stat.title}</div>
              <div className="text-xl font-semibold text-gray-900">{stat.value}</div>
              {stat.id === 7 && (
                <button onClick={() => setOpen(true)} className="mt-2 w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                  Withdraw
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* Withdraw Modal */}
      {open && (
        <>
          <div onClick={() => setOpen(false)} className="fixed inset-0 bg-black/50 z-40" />
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-xl w-[90%] max-w-md z-50">
            <div className="p-6 border-b border-gray-100 flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900">Withdraw Amount</h2>
              <button onClick={() => setOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors">
                <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-6">
              <p className="text-sm text-gray-600 mb-4">Enter your PayPal email to withdraw the amount.</p>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your PayPal email" className="w-full px-4 py-3 mb-4 bg-gray-50 border border-gray-300 rounded-xl focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all" />
              <button onClick={handleWithDraw} disabled={loading} className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                {loading ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : "Withdraw Amount"}
              </button>
            </div>
          </div>
        </>
      )}

      <PurchaseCourses />
    </div>
  );
};

export default TeacherDashboard;

